import cn from 'classnames';
import { Enum } from './enum';
export var ControlSizeType = Enum({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large'
});
export var ControlShapeType = Enum({
  SQUARED: 'squared',
  ROUNDED: 'rounded',
  CIRCULAR: 'circular'
});
export var ControlAppearanceType = Enum({
  MINIMAL: 'minimal',
  OUTLINE: 'outline',
  FILL: 'fill'
});
export var ControlDensityType = Enum({
  COMPACT: 'compact',
  NORMAL: 'normal',
  RELAXED: 'relaxed'
});
export function controlClasses(props) {
  return cn({
    '-sm': props.size === ControlSizeType.SMALL,
    '-lg': props.size === ControlSizeType.LARGE,
    '-rounded': props.shape === ControlShapeType.ROUNDED,
    '-circular': props.shape === ControlShapeType.CIRCULAR,
    '-squared': props.shape === ControlShapeType.SQUARED,
    '-compact': props.density === ControlDensityType.COMPACT,
    '-relaxed': props.density === ControlDensityType.RELAXED,
    '-outline': props.appearance === ControlAppearanceType.OUTLINE,
    '-fill': props.appearance === ControlAppearanceType.FILL,
    '-minimal': props.appearance === ControlAppearanceType.MINIMAL
  });
}